export const VALIDATION_CODE_TYPE = {
  DNI: 'DNI',
  EMPLOYEE_CODE: 'EMPLOYEE_CODE',
} as const;
